webpackJsonp([30],{

/***/ "2uFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '亿师学管理后台',
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: true,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: 'http://a5api.yishixue.net/admin/',
    pro: 'https://a5api.yishixue.net/admin/'
  },
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'home',
  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  }
});

/***/ }),

/***/ "BeJb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D3jw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Foau":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getIndexData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getCourseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return searchCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getCourseInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return saveCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return courseEnable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return searchUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return userEnable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return userResetpwd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return saveErrorLogger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getPresentLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return presentCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getOrderChangeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return orderChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return searchOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return cancelOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return salesTrackingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return salesTrackingUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return salesTrackingInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SignupParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SignupList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SignupUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FeedbackList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FeedbackUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FeedbackDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getCouponList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return searchCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return couponEnable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return couponMake; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CommentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommentEnable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CommentTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return sendCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return createUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return userCourseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return userCourseEnable; });
/* unused harmony export searchOfflineClasshour */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getOfflineClasshour; });
/* unused harmony export viewQrcode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return signInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return signCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return signSend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return sendLeavel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return searchUserByCourse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_api_request__ = __webpack_require__("xXZE");


var getIndexData = function getIndexData() {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'index',
    method: 'get'
  });
};

var getCourseList = function getCourseList(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'course-list',
    params: info,
    method: 'get'
  });
};

var searchCourse = function searchCourse(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'search-course',
    params: info,
    method: 'get'
  });
};

var getCourseInfo = function getCourseInfo(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'course-info',
    params: info,
    method: 'get'
  });
};

var saveCourse = function saveCourse(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'course-save',
    data: info,
    method: 'post'
  });
};

var courseEnable = function courseEnable(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'course-enable',
    data: info,
    method: 'post'
  });
};

var getUserList = function getUserList(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'user-list',
    params: info,
    method: 'get'
  });
};

var searchUser = function searchUser(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'search-user',
    params: info,
    method: 'get'
  });
};

var userEnable = function userEnable(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'user-enable',
    data: info,
    method: 'post'
  });
};

var userResetpwd = function userResetpwd(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'resetpwd',
    data: info,
    method: 'post'
  });
};

var saveErrorLogger = function saveErrorLogger(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'save-error-logger',
    data: info,
    method: 'post'
  });
};

var getPresentLog = function getPresentLog(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'present-log',
    params: info,
    method: 'get'
  });
};

var presentCourse = function presentCourse(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'present-course',
    data: info,
    method: 'post'
  });
};

var getOrderList = function getOrderList(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'order-list',
    params: info,
    method: 'get'
  });
};
var getOrderChangeList = function getOrderChangeList(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'order-change-list',
    params: info,
    method: 'get'
  });
};

var orderChange = function orderChange(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'order-change',
    data: info,
    method: 'post'
  });
};

var searchOrder = function searchOrder(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'search-order',
    params: info,
    method: 'get'
  });
};
var cancelOrder = function cancelOrder(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'cancel-order',
    data: info,
    method: 'post'
  });
};

var salesTrackingList = function salesTrackingList(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'sales-tracking-list',
    params: info,
    method: 'get'
  });
};

var salesTrackingUpdate = function salesTrackingUpdate(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'sales-tracking-update',
    data: info,
    method: 'post'
  });
};

var salesTrackingInfo = function salesTrackingInfo(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'sales-tracking-info',
    params: info,
    method: 'get'
  });
};

var SignupParams = function SignupParams(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'school-list',
    params: info,
    method: 'get'
  });
};

var SignupList = function SignupList(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'user-apply-list',
    params: info,
    method: 'get'
  });
};

var SignupUpdate = function SignupUpdate(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'user-apply-update',
    data: info,
    method: 'post'
  });
};

var FeedbackList = function FeedbackList(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'feedback-list',
    params: info,
    method: 'get'
  });
};

var FeedbackUpdate = function FeedbackUpdate(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'feedback-update',
    data: info,
    method: 'post'
  });
};

var FeedbackDelete = function FeedbackDelete(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'feedback-delete',
    data: info,
    method: 'post'
  });
};

var getCouponList = function getCouponList(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'coupon-list',
    params: info,
    method: 'get'
  });
};

var searchCoupon = function searchCoupon(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'search-coupon',
    params: info,
    method: 'get'
  });
};

var couponEnable = function couponEnable(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'coupon-enable',
    data: info,
    method: 'post'
  });
};

var couponMake = function couponMake(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'coupon-make',
    data: info,
    method: 'post'
  });
};

var CommentList = function CommentList(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'comment-list',
    params: info,
    method: 'get'
  });
};

var CommentEnable = function CommentEnable(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'comment-enable',
    data: info,
    method: 'post'
  });
};

var CommentTop = function CommentTop(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'comment-top',
    data: info,
    method: 'post'
  });
};

var sendCoupon = function sendCoupon(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'send-coupon',
    data: info,
    method: 'post'
  });
};

var createUser = function createUser(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'create-user',
    data: info,
    method: 'post'
  });
};

var userCourseList = function userCourseList(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'user-course-list',
    params: info,
    method: 'get'
  });
};

var userCourseEnable = function userCourseEnable(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'user-course-enable',
    data: info,
    method: 'post'
  });
};

var searchOfflineClasshour = function searchOfflineClasshour(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'search-offline-classhour',
    params: info,
    method: 'get'
  });
};

var getOfflineClasshour = function getOfflineClasshour(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'offline-classhour-list',
    params: info,
    method: 'get'
  });
};

var viewQrcode = function viewQrcode(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'view-qrcode',
    params: info,
    method: 'get'
  });
};
var signInfo = function signInfo(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'classhour-sign-info',
    params: info,
    method: 'get'
  });
};

var signCall = function signCall(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'classhour-sign-call',
    params: info,
    method: 'get'
  });
};

var signSend = function signSend(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'classhour-sign-send',
    params: info,
    method: 'get'
  });
};

var sendLeavel = function sendLeavel(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'classhour-sign-leavel',
    params: info,
    method: 'post'
  });
};

var searchUserByCourse = function searchUserByCourse(info) {
  return __WEBPACK_IMPORTED_MODULE_0__libs_api_request__["a" /* default */].request({
    url: 'classhour-search-user',
    params: info,
    method: 'get'
  });
};

/***/ }),

/***/ "H6S9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.11.1@vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("zX7l");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.11.1@vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.11.1@vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-272fb16e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.11.1@vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _vux_2_11_1_vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.11.1@vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("QbtL")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  _vux_2_11_1_vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules__vux_2_11_1_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vue@2.6.14@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("yf3K");

// EXTERNAL MODULE: ./node_modules/_vuex@2.5.0@vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("HVJf");

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/promise.js
var promise = __webpack_require__("rVsN");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./src/libs/api.request.js + 1 modules
var api_request = __webpack_require__("xXZE");

// CONCATENATED MODULE: ./src/api/user.js


var user_login = function login(_ref) {
  var userName = _ref.userName,
      password = _ref.password;

  var data = {
    username: userName,
    password: password
  };
  return api_request["a" /* default */].request({
    url: 'login',
    data: data,
    method: 'post'
  });
};

var user_getUserInfo = function getUserInfo(token) {
  return api_request["a" /* default */].request({
    url: 'get-info',
    params: {
      token: token
    },
    method: 'get'
  });
};

var user_logout = function logout(token) {
  return api_request["a" /* default */].request({
    url: 'logout',
    method: 'post'
  });
};

var user_getUnreadCount = function getUnreadCount() {
  return api_request["a" /* default */].request({
    url: 'message/count',
    method: 'get'
  });
};

var user_getMessage = function getMessage() {
  return api_request["a" /* default */].request({
    url: 'message/init',
    method: 'get'
  });
};

var user_getContentByMsgId = function getContentByMsgId(msg_id) {
  return api_request["a" /* default */].request({
    url: 'message/content',
    method: 'get',
    params: {
      msg_id: msg_id
    }
  });
};

var user_hasRead = function hasRead(msg_id) {
  return api_request["a" /* default */].request({
    url: 'message/has_read',
    method: 'post',
    data: {
      msg_id: msg_id
    }
  });
};

var user_removeReaded = function removeReaded(msg_id) {
  return api_request["a" /* default */].request({
    url: 'message/remove_readed',
    method: 'post',
    data: {
      msg_id: msg_id
    }
  });
};

var user_restoreTrash = function restoreTrash(msg_id) {
  return api_request["a" /* default */].request({
    url: 'message/restore',
    method: 'post',
    data: {
      msg_id: msg_id
    }
  });
};
// EXTERNAL MODULE: ./src/libs/util.js + 1 modules
var util = __webpack_require__("TVG1");

// CONCATENATED MODULE: ./src/store/module/user.js




/* harmony default export */ var user = ({
  state: {
    userName: '',
    userId: '',
    roleName: '',
    avatorImgPath: '',
    token: Object(util["g" /* getToken */])(),
    access: '',
    hasGetInfo: false,
    unreadCount: 0,
    messageUnreadList: [],
    messageReadedList: [],
    messageTrashList: [],
    messageContentStore: {}
  },
  mutations: {
    setAvator: function setAvator(state, avatorPath) {
      state.avatorImgPath = avatorPath;
    },
    setUserId: function setUserId(state, id) {
      state.userId = id;
    },
    setUserName: function setUserName(state, name) {
      state.userName = name;
    },
    setRoleName: function setRoleName(state, name) {
      state.roleName = name;
    },
    setAccess: function setAccess(state, access) {
      state.access = access;
    },
    setToken: function setToken(state, token) {
      state.token = token;
      Object(util["n" /* setToken */])(token);
    },
    setHasGetInfo: function setHasGetInfo(state, status) {
      state.hasGetInfo = status;
    },
    setMessageCount: function setMessageCount(state, count) {
      state.unreadCount = count;
    },
    setMessageUnreadList: function setMessageUnreadList(state, list) {
      state.messageUnreadList = list;
    },
    setMessageReadedList: function setMessageReadedList(state, list) {
      state.messageReadedList = list;
    },
    setMessageTrashList: function setMessageTrashList(state, list) {
      state.messageTrashList = list;
    },
    updateMessageContentStore: function updateMessageContentStore(state, _ref) {
      var msg_id = _ref.msg_id,
          content = _ref.content;

      state.messageContentStore[msg_id] = content;
    },
    moveMsg: function moveMsg(state, _ref2) {
      var from = _ref2.from,
          to = _ref2.to,
          msg_id = _ref2.msg_id;

      var index = state[from].findIndex(function (_) {
        return _.msg_id === msg_id;
      });
      var msgItem = state[from].splice(index, 1)[0];
      msgItem.loading = false;
      state[to].unshift(msgItem);
    }
  },
  getters: {
    messageUnreadCount: function messageUnreadCount(state) {
      return state.messageUnreadList.length;
    },
    messageReadedCount: function messageReadedCount(state) {
      return state.messageReadedList.length;
    },
    messageTrashCount: function messageTrashCount(state) {
      return state.messageTrashList.length;
    }
  },
  actions: {
    // 登录
    handleLogin: function handleLogin(_ref3, _ref4) {
      var commit = _ref3.commit;
      var userName = _ref4.userName,
          password = _ref4.password;

      userName = userName.trim();
      return new promise_default.a(function (resolve, reject) {
        user_login({
          userName: userName,
          password: password
        }).then(function (res) {
          var data = res.data.data;
          commit('setToken', data.token);
          resolve();
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    // 退出登录
    handleLogOut: function handleLogOut(_ref5) {
      var state = _ref5.state,
          commit = _ref5.commit;

      return new promise_default.a(function (resolve, reject) {
        user_logout(state.token).then(function () {
          commit('setToken', '');
          commit('setAccess', []);
          resolve();
        }).catch(function (err) {
          reject(err);
        });
        // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
        // commit('setToken', '')
        // commit('setAccess', [])
        // resolve()
      });
    },

    // 获取用户相关信息
    getUserInfo: function getUserInfo(_ref6) {
      var state = _ref6.state,
          commit = _ref6.commit;

      return new promise_default.a(function (resolve, reject) {
        try {
          user_getUserInfo(state.token).then(function (res) {
            var data = res.data.data;
            commit('setAvator', data.avator);
            commit('setUserName', data.name);
            commit('setUserId', data.user_id);
            commit('setAccess', data.access);
            commit('setRoleName', data.role_name);
            commit('setHasGetInfo', true);
            resolve(data);
          }).catch(function (err) {
            reject(err);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    // 此方法用来获取未读消息条数，接口只返回数值，不返回消息列表
    getUnreadMessageCount: function getUnreadMessageCount(_ref7) {
      var state = _ref7.state,
          commit = _ref7.commit;

      user_getUnreadCount().then(function (res) {
        var data = res.data;

        commit('setMessageCount', data);
      });
    },

    // 获取消息列表，其中包含未读、已读、回收站三个列表
    getMessageList: function getMessageList(_ref8) {
      var state = _ref8.state,
          commit = _ref8.commit;

      return new promise_default.a(function (resolve, reject) {
        user_getMessage().then(function (res) {
          var _res$data = res.data,
              unread = _res$data.unread,
              readed = _res$data.readed,
              trash = _res$data.trash;

          commit('setMessageUnreadList', unread.sort(function (a, b) {
            return new Date(b.create_time) - new Date(a.create_time);
          }));
          commit('setMessageReadedList', readed.map(function (_) {
            _.loading = false;
            return _;
          }).sort(function (a, b) {
            return new Date(b.create_time) - new Date(a.create_time);
          }));
          commit('setMessageTrashList', trash.map(function (_) {
            _.loading = false;
            return _;
          }).sort(function (a, b) {
            return new Date(b.create_time) - new Date(a.create_time);
          }));
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    // 根据当前点击的消息的id获取内容
    getContentByMsgId: function getContentByMsgId(_ref9, _ref10) {
      var state = _ref9.state,
          commit = _ref9.commit;
      var msg_id = _ref10.msg_id;

      return new promise_default.a(function (resolve, reject) {
        var contentItem = state.messageContentStore[msg_id];
        if (contentItem) {
          resolve(contentItem);
        } else {
          user_getContentByMsgId(msg_id).then(function (res) {
            var content = res.data;
            commit('updateMessageContentStore', { msg_id: msg_id, content: content });
            resolve(content);
          });
        }
      });
    },

    // 把一个未读消息标记为已读
    hasRead: function hasRead(_ref11, _ref12) {
      var state = _ref11.state,
          commit = _ref11.commit;
      var msg_id = _ref12.msg_id;

      return new promise_default.a(function (resolve, reject) {
        user_hasRead(msg_id).then(function () {
          commit('moveMsg', {
            from: 'messageUnreadList',
            to: 'messageReadedList',
            msg_id: msg_id
          });
          commit('setMessageCount', state.unreadCount - 1);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    // 删除一个已读消息到回收站
    removeReaded: function removeReaded(_ref13, _ref14) {
      var commit = _ref13.commit;
      var msg_id = _ref14.msg_id;

      return new promise_default.a(function (resolve, reject) {
        user_removeReaded(msg_id).then(function () {
          commit('moveMsg', {
            from: 'messageReadedList',
            to: 'messageTrashList',
            msg_id: msg_id
          });
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    // 还原一个已删除消息到已读消息
    restoreTrash: function restoreTrash(_ref15, _ref16) {
      var commit = _ref15.commit;
      var msg_id = _ref16.msg_id;

      return new promise_default.a(function (resolve, reject) {
        user_restoreTrash(msg_id).then(function () {
          commit('moveMsg', {
            from: 'messageTrashList',
            to: 'messageReadedList',
            msg_id: msg_id
          });
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }
});
// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("4YfN");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("IHPB");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./src/api/data.js
var api_data = __webpack_require__("Foau");

// EXTERNAL MODULE: ./src/router/index.js + 1 modules
var src_router = __webpack_require__("YaEn");

// EXTERNAL MODULE: ./src/config/index.js
var config = __webpack_require__("2uFj");

// CONCATENATED MODULE: ./src/store/module/app.js






var homeName = config["a" /* default */].homeName;


var app_closePage = function closePage(state, route) {
  var nextRoute = Object(util["d" /* getNextRoute */])(state.tagNavList, route);
  state.tagNavList = state.tagNavList.filter(function (item) {
    return !Object(util["j" /* routeEqual */])(item, route);
  });
  src_router["a" /* default */].push(nextRoute);
};

/* harmony default export */ var app = ({
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    local: Object(util["h" /* localRead */])('local'),
    errorList: [],
    hasReadErrorPage: false,
    isLoading: false
  },
  getters: {
    //menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access),
    errorCount: function errorCount(state) {
      return state.errorList.length;
    }
  },
  mutations: {
    setBreadCrumb: function setBreadCrumb(state, route) {
      state.breadCrumbList = Object(util["b" /* getBreadCrumbList */])(route, state.homeRoute);
    },
    setHomeRoute: function setHomeRoute(state, routes) {
      state.homeRoute = Object(util["c" /* getHomeRoute */])(routes, homeName);
    },
    setTagNavList: function setTagNavList(state, list) {
      var tagList = [];
      if (list) {
        tagList = [].concat(toConsumableArray_default()(list));
      } else tagList = Object(util["f" /* getTagNavListFromLocalstorage */])() || [];
      if (tagList[0] && tagList[0].name !== homeName) tagList.shift();
      var homeTagIndex = tagList.findIndex(function (item) {
        return item.name === homeName;
      });
      if (homeTagIndex > 0) {
        var homeTag = tagList.splice(homeTagIndex, 1)[0];
        tagList.unshift(homeTag);
      }
      state.tagNavList = tagList;
      Object(util["l" /* setTagNavListInLocalstorage */])([].concat(toConsumableArray_default()(tagList)));
    },
    closeTag: function closeTag(state, route) {
      var tag = state.tagNavList.filter(function (item) {
        return Object(util["j" /* routeEqual */])(item, route);
      });
      route = tag[0] ? tag[0] : null;
      if (!route) return;
      app_closePage(state, route);
    },
    addTag: function addTag(state, _ref) {
      var route = _ref.route,
          _ref$type = _ref.type,
          type = _ref$type === undefined ? 'unshift' : _ref$type;

      var router = Object(util["e" /* getRouteTitleHandled */])(route);
      if (!Object(util["k" /* routeHasExist */])(state.tagNavList, router)) {
        if (type === 'push') state.tagNavList.push(router);else {
          if (router.name === homeName) state.tagNavList.unshift(router);else state.tagNavList.splice(1, 0, router);
        }
        Object(util["l" /* setTagNavListInLocalstorage */])([].concat(toConsumableArray_default()(state.tagNavList)));
      }
    },
    setLocal: function setLocal(state, lang) {
      Object(util["i" /* localSave */])('local', lang);
      state.local = lang;
    },
    addError: function addError(state, error) {
      state.errorList.push(error);
    },
    setHasReadErrorLoggerStatus: function setHasReadErrorLoggerStatus(state) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      state.hasReadErrorPage = status;
    },
    updateLoadingStatus: function updateLoadingStatus(state, payload) {
      state.isLoading = payload.isLoading;
    }
  },
  actions: {
    addErrorLog: function addErrorLog(_ref2, info) {
      var commit = _ref2.commit,
          rootState = _ref2.rootState;

      if (!window.location.href.includes('error_logger_page')) commit('setHasReadErrorLoggerStatus', false);
      var _rootState$user = rootState.user,
          token = _rootState$user.token,
          userId = _rootState$user.userId,
          userName = _rootState$user.userName;

      var data = extends_default()({}, info, {
        time: Date.parse(new Date()),
        token: token,
        userId: userId,
        userName: userName
      });
      Object(api_data["D" /* saveErrorLogger */])(info).then(function () {
        commit('addError', data);
      });
    }
  }
});
// CONCATENATED MODULE: ./src/store/index.js





vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = __webpack_exports__["a"] = (new vuex_esm["a" /* default */].Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    user: user,
    app: app
  }
}));

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/_vue@2.6.14@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("yf3K");

// CONCATENATED MODULE: ./src/bus.js

var Bus = new vue_esm["a" /* default */]();
/* harmony default export */ var bus = (Bus);
// EXTERNAL MODULE: ./node_modules/_fastclick@1.0.6@fastclick/lib/fastclick.js
var fastclick = __webpack_require__("iDdd");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./src/router/index.js + 1 modules
var router = __webpack_require__("YaEn");

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("4YfN");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.11.1@vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.11.1@vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-00a67e59","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.11.1@vux/src/components/loading/index.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: loading_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.11.1@vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("wJUw")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var _vux_2_11_1_vux_src_components_loading = (Component.exports);

// EXTERNAL MODULE: ./node_modules/_vuex@2.5.0@vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("HVJf");

// EXTERNAL MODULE: ./node_modules/_vux@2.11.1@vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("4iwg");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.11.1@vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.11.1@vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar_tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-f57eff4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.11.1@vux/src/components/tabbar/tabbar.vue
var tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabbar"},[_vm._t("default")],2)}
var tabbar_staticRenderFns = []
var tabbar_esExports = { render: tabbar_render, staticRenderFns: tabbar_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar = (tabbar_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.11.1@vux/src/components/tabbar/tabbar.vue
function tabbar_injectStyle (ssrContext) {
  __webpack_require__("D3jw")
}
var tabbar_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var tabbar___vue_template_functional__ = false
/* styles */
var tabbar___vue_styles__ = tabbar_injectStyle
/* scopeId */
var tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar___vue_module_identifier__ = null
var tabbar_Component = tabbar_normalizeComponent(
  tabbar_tabbar,
  components_tabbar_tabbar,
  tabbar___vue_template_functional__,
  tabbar___vue_styles__,
  tabbar___vue_scopeId__,
  tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar = (tabbar_Component.exports);

// EXTERNAL MODULE: ./node_modules/_vux@2.11.1@vux/src/components/badge/index.vue + 3 modules
var badge = __webpack_require__("f/mU");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.11.1@vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: badge["a" /* default */]
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.11.1@vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: badge["a" /* default */]
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c069aa14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.11.1@vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-tabbar__item",class:{'weui-bar__item_on': _vm.isActive, 'vux-tabbar-simple': _vm.simple},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onItemClick(true)}}},[(!_vm.simple)?_c('div',{staticClass:"weui-tabbar__icon",class:[_vm.iconClass || _vm.$parent.iconClass, {'vux-reddot': _vm.showDot}]},[(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive))?_vm._t("icon"):_vm._e(),_vm._v(" "),(!_vm.simple && _vm.hasActiveIcon && _vm.isActive)?_vm._t("icon-active"):_vm._e(),_vm._v(" "),(_vm.badge)?_c('sup',[_c('badge',{attrs:{"text":_vm.badge}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"weui-tabbar__label"},[_vm._t("label")],2)])}
var tabbar_item_staticRenderFns = []
var tabbar_item_esExports = { render: tabbar_item_render, staticRenderFns: tabbar_item_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar_item = (tabbar_item_esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.11.1@vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var tabbar_item___vue_template_functional__ = false
/* styles */
var tabbar_item___vue_styles__ = null
/* scopeId */
var tabbar_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar_item___vue_module_identifier__ = null
var tabbar_item_Component = tabbar_item_normalizeComponent(
  tabbar_tabbar_item,
  components_tabbar_tabbar_item,
  tabbar_item___vue_template_functional__,
  tabbar_item___vue_styles__,
  tabbar_item___vue_scopeId__,
  tabbar_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar_item = (tabbar_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/FootBar.vue




/* harmony default export */ var FootBar = ({
  components: {
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/FootBar.vue




/* harmony default export */ var components_FootBar = ({
  components: {
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1e7fcc22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/FootBar.vue
var FootBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabbar',[_c('tabbar-item',{attrs:{"selected":"","link":"/"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("首页")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/course"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("课程")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/user"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("用户")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/mine"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("其他")])])],1)}
var FootBar_staticRenderFns = []
var FootBar_esExports = { render: FootBar_render, staticRenderFns: FootBar_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_FootBar = (FootBar_esExports);
// CONCATENATED MODULE: ./src/components/FootBar.vue
function FootBar_injectStyle (ssrContext) {
  __webpack_require__("RBIA")
}
var FootBar_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var FootBar___vue_template_functional__ = false
/* styles */
var FootBar___vue_styles__ = FootBar_injectStyle
/* scopeId */
var FootBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FootBar___vue_module_identifier__ = null
var FootBar_Component = FootBar_normalizeComponent(
  components_FootBar,
  selectortype_template_index_0_src_components_FootBar,
  FootBar___vue_template_functional__,
  FootBar___vue_styles__,
  FootBar___vue_scopeId__,
  FootBar___vue_module_identifier__
)

/* harmony default export */ var src_components_FootBar = (FootBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue






/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return { "isNotLoginPage": true };
  },

  components: {
    Loading: _vux_2_11_1_vux_src_components_loading,
    FootBar: src_components_FootBar
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    isLoading: function isLoading(state) {
      return state.app.isLoading;
    }
  })),
  mounted: function mounted() {
    var _this = this;

    this.$bus.$on('isNotLoginPage', function (data) {
      _this.isNotLoginPage = data;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue






/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  data: function data() {
    return { "isNotLoginPage": true };
  },

  components: {
    Loading: _vux_2_11_1_vux_src_components_loading,
    FootBar: src_components_FootBar
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    isLoading: function isLoading(state) {
      return state.app.isLoading;
    }
  })),
  mounted: function mounted() {
    var _this = this;

    this.$bus.$on('isNotLoginPage', function (data) {
      _this.isNotLoginPage = data;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-35f1aaa6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"margin-bottom":"30px"}},[_c('loading',{model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}}),_vm._v(" "),_c('router-view')],1),_vm._v(" "),(_vm.isNotLoginPage)?_c('FootBar'):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("BeJb")
}
var App_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./src/store/index.js + 3 modules
var store = __webpack_require__("IcnI");

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// import vConsole from '../static/vconsole.main.js'

// var vvConsole=new vConsole();
fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;
vue_esm["a" /* default */].prototype.$bus = bus;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: router["a" /* default */],
  store: store["a" /* default */],
  //vvConsole,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "OQnN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QaDJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QbtL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RBIA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TVG1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/promise.js
var promise = __webpack_require__("rVsN");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("3cXf");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("IHPB");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("4YfN");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/_js-cookie@3.0.1@js-cookie/dist/js.cookie.js
var js_cookie = __webpack_require__("H5US");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/config/index.js
var config = __webpack_require__("2uFj");

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("ZLEe");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/set.js
var set = __webpack_require__("zsLt");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/array/from.js
var from = __webpack_require__("kfHR");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// CONCATENATED MODULE: ./src/libs/tools.js




var forEach = function forEach(arr, fn) {
  if (!arr.length || !fn) return;
  var i = -1;
  var len = arr.length;
  while (++i < len) {
    var item = arr[i];
    fn(item, i, arr);
  }
};

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的交集, 两个数组的元素为数值或字符串
 */
var getIntersection = function getIntersection(arr1, arr2) {
  var len = Math.min(arr1.length, arr2.length);
  var i = -1;
  var res = [];
  while (++i < len) {
    var item = arr2[i];
    if (arr1.indexOf(item) > -1) res.push(item);
  }
  return res;
};

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的并集, 两个数组的元素为数值或字符串
 */
var tools_getUnion = function getUnion(arr1, arr2) {
  return from_default()(new set_default.a([].concat(toConsumableArray_default()(arr1), toConsumableArray_default()(arr2))));
};

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
var hasOneOf = function hasOneOf(targetarr, arr) {
  return targetarr.some(function (_) {
    return arr.indexOf(_) > -1;
  });
};

/**
 * @param {String|Number} value 要验证的字符串或数值
 * @param {*} validList 用来验证的列表
 */
function oneOf(value, validList) {
  for (var i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}

/**
 * @param {Number} timeStamp 判断时间戳格式是否是毫秒
 * @returns {Boolean}
 */
var isMillisecond = function isMillisecond(timeStamp) {
  var timeStr = String(timeStamp);
  return timeStr.length > 10;
};

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} currentTime 当前时间时间戳
 * @returns {Boolean} 传入的时间戳是否早于当前时间戳
 */
var isEarly = function isEarly(timeStamp, currentTime) {
  return timeStamp < currentTime;
};

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
var getHandledValue = function getHandledValue(num) {
  return num < 10 ? '0' + num : num;
};

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} startType 要返回的时间字符串的格式类型，传入'year'则返回年开头的完整时间
 */
var getDate = function getDate(timeStamp, startType) {
  var d = new Date(timeStamp * 1000);
  var year = d.getFullYear();
  var month = getHandledValue(d.getMonth() + 1);
  var date = getHandledValue(d.getDate());
  var hours = getHandledValue(d.getHours());
  var minutes = getHandledValue(d.getMinutes());
  var second = getHandledValue(d.getSeconds());
  var resStr = '';
  if (startType === 'year') resStr = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + second;else resStr = month + '-' + date + ' ' + hours + ':' + minutes;
  return resStr;
};

/**
 * @param {String|Number} timeStamp 时间戳
 * @returns {String} 相对时间字符串
 */
var getRelativeTime = function getRelativeTime(timeStamp) {
  // 判断当前传入的时间戳是秒格式还是毫秒
  var IS_MILLISECOND = isMillisecond(timeStamp);
  // 如果是毫秒格式则转为秒格式
  if (IS_MILLISECOND) Math.floor(timeStamp /= 1000);
  // 传入的时间戳可以是数值或字符串类型，这里统一转为数值类型
  timeStamp = Number(timeStamp);
  // 获取当前时间时间戳
  var currentTime = Math.floor(Date.parse(new Date()) / 1000);
  // 判断传入时间戳是否早于当前时间戳
  var IS_EARLY = isEarly(timeStamp, currentTime);
  // 获取两个时间戳差值
  var diff = currentTime - timeStamp;
  // 如果IS_EARLY为false则差值取反
  if (!IS_EARLY) diff = -diff;
  var resStr = '';
  var dirStr = IS_EARLY ? '前' : '后';
  // 少于等于59秒
  if (diff <= 59) resStr = diff + '秒' + dirStr;
  // 多于59秒，少于等于59分钟59秒
  else if (diff > 59 && diff <= 3599) resStr = Math.floor(diff / 60) + '分钟' + dirStr;
    // 多于59分钟59秒，少于等于23小时59分钟59秒
    else if (diff > 3599 && diff <= 86399) resStr = Math.floor(diff / 3600) + '小时' + dirStr;
      // 多于23小时59分钟59秒，少于等于29天59分钟59秒
      else if (diff > 86399 && diff <= 2623859) resStr = Math.floor(diff / 86400) + '天' + dirStr;
        // 多于29天59分钟59秒，少于364天23小时59分钟59秒，且传入的时间戳早于当前
        else if (diff > 2623859 && diff <= 31567859 && IS_EARLY) resStr = getDate(timeStamp);else resStr = getDate(timeStamp, 'year');
  return resStr;
};

/**
 * @returns {String} 当前浏览器名称
 */
var getExplorer = function getExplorer() {
  var ua = window.navigator.userAgent;
  var isExplorer = function isExplorer(exp) {
    return ua.indexOf(exp) > -1;
  };
  if (isExplorer('MSIE')) return 'IE';else if (isExplorer('Firefox')) return 'Firefox';else if (isExplorer('Chrome')) return 'Chrome';else if (isExplorer('Opera')) return 'Opera';else if (isExplorer('Safari')) return 'Safari';
};

/**
 * @description 绑定事件 on(element, event, handler)
 */
var on = function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/**
 * @description 解绑事件 off(element, event, handler)
 */
var off = function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/**
 * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
 * 如果没有传入key这个参数，则判断obj对象是否有键值对
 */
var tools_hasKey = function hasKey(obj, key) {
  if (key) return key in obj;else {
    var keysArr = keys_default()(obj);
    return keysArr.length;
  }
};

/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
var tools_objEqual = function objEqual(obj1, obj2) {
  var keysArr1 = keys_default()(obj1);
  var keysArr2 = keys_default()(obj2);
  if (keysArr1.length !== keysArr2.length) return false;else if (keysArr1.length === 0 && keysArr2.length === 0) return true;
  /* eslint-disable-next-line */
  else return !keysArr1.some(function (key) {
      return obj1[key] != obj2[key];
    });
};
// CONCATENATED MODULE: ./src/libs/util.js
/* unused harmony export TOKEN_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return util_setToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return util_getToken; });
/* unused harmony export hasChild */
/* unused harmony export getMenuByRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return util_getBreadCrumbList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return util_getRouteTitleHandled; });
/* unused harmony export showTitle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return util_setTagNavListInLocalstorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTagNavListFromLocalstorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getHomeRoute; });
/* unused harmony export getNewTagList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canTurnTo; });
/* unused harmony export getParams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getNextRoute; });
/* unused harmony export doCustomTimes */
/* unused harmony export getArrayFromFile */
/* unused harmony export getTableDataFromArray */
/* unused harmony export findNodeUpper */
/* unused harmony export findNodeUpperByClasses */
/* unused harmony export findNodeDownward */
/* unused harmony export showByAccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return util_routeEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return routeHasExist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return localSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return localRead; });
/* unused harmony export scrollTop */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setTitle; });





// cookie保存的天数


var util_title = config["a" /* default */].title,
    cookieExpires = config["a" /* default */].cookieExpires,
    useI18n = config["a" /* default */].useI18n;


var TOKEN_KEY = 'token';

var util_setToken = function setToken(token) {
  js_cookie_default.a.set(TOKEN_KEY, token, { expires: cookieExpires || 1 });
};

var util_getToken = function getToken() {
  var token = js_cookie_default.a.get(TOKEN_KEY);
  if (token) return token;else return false;
};

var hasChild = function hasChild(item) {
  return item.children && item.children.length !== 0;
};

var util_showThisMenuEle = function showThisMenuEle(item, access) {
  if (item.meta && item.meta.access && item.meta.access.length) {
    if (hasOneOf(item.meta.access, access)) return true;else return false;
  } else return true;
};
/**
 * @param {Array} list 通过路由列表得到菜单列表
 * @returns {Array}
 */
var util_getMenuByRouter = function getMenuByRouter(list, access) {
  var res = [];
  forEach(list, function (item) {
    if (!item.meta || item.meta && !item.meta.hideInMenu) {
      var obj = {
        icon: item.meta && item.meta.icon || '',
        name: item.name,
        meta: item.meta
      };
      if ((hasChild(item) || item.meta && item.meta.showAlways) && util_showThisMenuEle(item, access)) {
        obj.children = getMenuByRouter(item.children, access);
      }
      if (item.meta && item.meta.href) obj.href = item.meta.href;
      if (util_showThisMenuEle(item, access)) res.push(obj);
    }
  });
  return res;
};

/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
var util_getBreadCrumbList = function getBreadCrumbList(route, homeRoute) {
  var homeItem = extends_default()({}, homeRoute, { icon: homeRoute.meta.icon });
  var routeMetched = route.matched;
  if (routeMetched.some(function (item) {
    return item.name === homeRoute.name;
  })) return [homeItem];
  var res = routeMetched.filter(function (item) {
    return item.meta === undefined || !item.meta.hideInBread;
  }).map(function (item) {
    var meta = extends_default()({}, item.meta);
    if (meta.title && typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true;
      meta.title = meta.title(route);
    }
    var obj = {
      icon: item.meta && item.meta.icon || '',
      name: item.name,
      meta: meta
    };
    return obj;
  });
  res = res.filter(function (item) {
    return !item.meta.hideInMenu;
  });
  return [extends_default()({}, homeItem, { to: homeRoute.path })].concat(toConsumableArray_default()(res));
};

var util_getRouteTitleHandled = function getRouteTitleHandled(route) {
  var router = extends_default()({}, route);
  var meta = extends_default()({}, route.meta);
  var title = '';
  if (meta.title) {
    if (typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true;
      title = meta.title(router);
    } else title = meta.title;
  }
  meta.title = title;
  router.meta = meta;
  return router;
};

var showTitle = function showTitle(item, vm) {
  var _item$meta = item.meta,
      title = _item$meta.title,
      __titleIsFunction__ = _item$meta.__titleIsFunction__;

  if (!title) return;
  title = item.meta && item.meta.title || item.name;
  return title;
};

/**
 * @description 本地存储和获取标签导航列表
 */
var util_setTagNavListInLocalstorage = function setTagNavListInLocalstorage(list) {
  localStorage.tagNaveList = stringify_default()(list);
};
/**
 * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
 */
var getTagNavListFromLocalstorage = function getTagNavListFromLocalstorage() {
  var list = localStorage.tagNaveList;
  return list ? JSON.parse(list) : [];
};

/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */
var getHomeRoute = function getHomeRoute(routers) {
  var homeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'home';

  var i = -1;
  var len = routers.length;
  var homeRoute = {};
  while (++i < len) {
    var item = routers[i];
    if (item.children && item.children.length) {
      var res = getHomeRoute(item.children, homeName);
      if (res.name) return res;
    } else {
      if (item.name === homeName) homeRoute = item;
    }
  }
  return homeRoute;
};

/**
 * @param {*} list 现有标签导航列表
 * @param {*} newRoute 新添加的路由原信息对象
 * @description 如果该newRoute已经存在则不再添加
 */
var util_getNewTagList = function getNewTagList(list, newRoute) {
  var name = newRoute.name,
      path = newRoute.path,
      meta = newRoute.meta;

  var newList = [].concat(toConsumableArray_default()(list));
  if (newList.findIndex(function (item) {
    return item.name === name;
  }) >= 0) return newList;else newList.push({ name: name, path: path, meta: meta });
  return newList;
};

/**
 * @param {*} access 用户权限数组，如 ['super_admin', 'admin']
 * @param {*} route 路由列表
 */
var util_hasAccess = function hasAccess(access, route) {
  if (route.meta && route.meta.access) return hasOneOf(access, route.meta.access);else return true;
};

/**
 * 权鉴
 * @param {*} name 即将跳转的路由name
 * @param {*} access 用户权限数组
 * @param {*} routes 路由列表
 * @description 用户是否可跳转到该页
 */
var canTurnTo = function canTurnTo(name, access, routes) {
  var routePermissionJudge = function routePermissionJudge(list) {
    return list.some(function (item) {
      if (item.children && item.children.length) {
        return routePermissionJudge(item.children);
      } else if (item.name === name) {
        return util_hasAccess(access, item);
      }
    });
  };
  return routePermissionJudge(routes);
};

/**
 * @param {String} url
 * @description 从URL中解析参数
 */
var getParams = function getParams(url) {
  var keyValueArr = url.split('?')[1].split('&');
  var paramObj = {};
  keyValueArr.forEach(function (item) {
    var keyValue = item.split('=');
    paramObj[keyValue[0]] = keyValue[1];
  });
  return paramObj;
};

/**
 * @param {Array} list 标签列表
 * @param {String} name 当前关闭的标签的name
 */
var getNextRoute = function getNextRoute(list, route) {
  var res = {};
  if (list.length === 2) {
    res = getHomeRoute(list);
  } else {
    var index = list.findIndex(function (item) {
      return util_routeEqual(item, route);
    });
    if (index === list.length - 1) res = list[list.length - 2];else res = list[index + 1];
  }
  return res;
};

/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
var doCustomTimes = function doCustomTimes(times, callback) {
  var i = -1;
  while (++i < times) {
    callback(i);
  }
};

/**
 * @param {Object} file 从上传组件得到的文件对象
 * @returns {Promise} resolve参数是解析后的二维数组
 * @description 从Csv文件中解析出表格，解析成二维数组
 */
var util_getArrayFromFile = function getArrayFromFile(file) {
  var nameSplit = file.name.split('.');
  var format = nameSplit[nameSplit.length - 1];
  return new promise_default.a(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsText(file); // 以文本格式读取
    var arr = [];
    reader.onload = function (evt) {
      var data = evt.target.result; // 读到的数据
      var pasteData = data.trim();
      arr = pasteData.split(/[\n\u0085\u2028\u2029]|\r\n?/g).map(function (row) {
        return row.split('\t');
      }).map(function (item) {
        return item[0].split(',');
      });
      if (format === 'csv') resolve(arr);else reject(new Error('[Format Error]:你上传的不是Csv文件'));
    };
  });
};

/**
 * @param {Array} array 表格数据二维数组
 * @returns {Object} { columns, tableData }
 * @description 从二维数组中获取表头和表格数据，将第一行作为表头，用于在iView的表格中展示数据
 */
var getTableDataFromArray = function getTableDataFromArray(array) {
  var columns = [];
  var tableData = [];
  if (array.length > 1) {
    var titles = array.shift();
    columns = titles.map(function (item) {
      return {
        title: item,
        key: item
      };
    });
    tableData = array.map(function (item) {
      var res = {};
      item.forEach(function (col, i) {
        res[titles[i]] = col;
      });
      return res;
    });
  }
  return {
    columns: columns,
    tableData: tableData
  };
};

var findNodeUpper = function findNodeUpper(ele, tag) {
  if (ele.parentNode) {
    if (ele.parentNode.tagName === tag.toUpperCase()) {
      return ele.parentNode;
    } else {
      return findNodeUpper(ele.parentNode, tag);
    }
  }
};

var findNodeUpperByClasses = function findNodeUpperByClasses(ele, classes) {
  var parentNode = ele.parentNode;
  if (parentNode) {
    var classList = parentNode.classList;
    if (classList && classes.every(function (className) {
      return classList.contains(className);
    })) {
      return parentNode;
    } else {
      return findNodeUpperByClasses(parentNode, classes);
    }
  }
};

var findNodeDownward = function findNodeDownward(ele, tag) {
  var tagName = tag.toUpperCase();
  if (ele.childNodes.length) {
    var i = -1;
    var len = ele.childNodes.length;
    while (++i < len) {
      var child = ele.childNodes[i];
      if (child.tagName === tagName) return child;else return findNodeDownward(child, tag);
    }
  }
};

var util_showByAccess = function showByAccess(access, canViewAccess) {
  return hasOneOf(canViewAccess, access);
};

/**
 * @description 根据name/params/query判断两个路由对象是否相等
 * @param {*} route1 路由对象
 * @param {*} route2 路由对象
 */
var util_routeEqual = function routeEqual(route1, route2) {
  var params1 = route1.params || {};
  var params2 = route2.params || {};
  var query1 = route1.query || {};
  var query2 = route2.query || {};
  return route1.name === route2.name && tools_objEqual(params1, params2) && tools_objEqual(query1, query2);
};

/**
 * 判断打开的标签列表里是否已存在这个新添加的路由对象
 */
var routeHasExist = function routeHasExist(tagNavList, routeItem) {
  var len = tagNavList.length;
  var res = false;
  doCustomTimes(len, function (index) {
    if (util_routeEqual(tagNavList[index], routeItem)) res = true;
  });
  return res;
};

var localSave = function localSave(key, value) {
  localStorage.setItem(key, value);
};

var localRead = function localRead(key) {
  return localStorage.getItem(key) || '';
};

// scrollTop animation
var scrollTop = function scrollTop(el) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var to = arguments[2];
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
  var endCallback = arguments[4];

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    };
  }
  var difference = Math.abs(from - to);
  var step = Math.ceil(difference / duration * 50);

  var scroll = function scroll(start, end, step) {
    if (start === end) {
      endCallback && endCallback();
      return;
    }

    var d = start + step > end ? end : start + step;
    if (start > end) {
      d = start - step < end ? end : start - step;
    }

    if (el === window) {
      window.scrollTo(d, d);
    } else {
      el.scrollTop = d;
    }
    window.requestAnimationFrame(function () {
      return scroll(d, end, step);
    });
  };
  scroll(from, to, step);
};

/**
 * @description 根据当前跳转的路由设置显示在浏览器标签的title
 * @param {Object} routeItem 路由对象
 * @param {Object} vm Vue实例
 */
var setTitle = function setTitle(routeItem, vm) {
  var handledRoute = util_getRouteTitleHandled(routeItem);
  var pageTitle = showTitle(handledRoute, vm);
  var resTitle = pageTitle ? util_title + ' - ' + pageTitle : util_title;
  window.document.title = resTitle;
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vue@2.6.14@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("yf3K");

// EXTERNAL MODULE: ./node_modules/_vue-router@3.5.3@vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("ddSS");

// CONCATENATED MODULE: ./src/router/routers.js
/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */
var Home = function Home() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "2NXm"));
};
var Mine = function Mine() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "bdlY"));
};
var Course = function Course() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(__webpack_require__.bind(null, "k6k6"));
};
var CourseInfo = function CourseInfo() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "xA+y"));
};
var User = function User() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "hsIW"));
};
var CreateUser = function CreateUser() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, "qzQS"));
};
var GiveCourse = function GiveCourse() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, "rrqY"));
};
var GiveCoupon = function GiveCoupon() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(__webpack_require__.bind(null, "x2/0"));
};
var UserCourse = function UserCourse() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, "9TBt"));
};
var UserOrder = function UserOrder() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, "PEs7"));
};
var Order = function Order() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "sRrG"));
};
var OrderInfo = function OrderInfo() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, "Bk9V"));
};
var OrderChange = function OrderChange() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, "cjMJ"));
};
var Login = function Login() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, "P7ry"));
};
var error_401 = function error_401() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(__webpack_require__.bind(null, "FJwH"));
};
var SalesTracking = function SalesTracking() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "PPRR"));
};
var SalesTrackingView = function SalesTrackingView() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, "sX8r"));
};
var SalesTrackingInfo = function SalesTrackingInfo() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, "Fezr"));
};
var Signup = function Signup() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "y53x"));
};
var SignupView = function SignupView() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(__webpack_require__.bind(null, "WZuo"));
};
var SignupInfo = function SignupInfo() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(__webpack_require__.bind(null, "D0s/"));
};
var Feedback = function Feedback() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "ZIHb"));
};
var Comment = function Comment() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "V3og"));
};
var Coupon = function Coupon() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(__webpack_require__.bind(null, "5jrs"));
};
var Test = function Test() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(__webpack_require__.bind(null, "Y7I0"));
};
var Classhour = function Classhour() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(__webpack_require__.bind(null, "Tho8"));
};
var ClasshourQrcode = function ClasshourQrcode() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "mX/7"));
};
var ClasshourSign = function ClasshourSign() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, "Xq6i"));
};
/* harmony default export */ var routers = ([{
  path: '/',
  name: 'home',
  component: Home,
  meta: {
    title: "首页"
  }
}, {
  path: '/mine',
  name: 'other',
  component: Mine,
  meta: {
    title: "其他"
  }
}, {
  path: '/course',
  name: 'course',
  component: Course,
  meta: {
    title: "课程"
  }
}, {
  path: '/course/info',
  name: 'corse-info',
  component: CourseInfo,
  meta: {
    title: "课程详情"
  }
}, {
  path: '/user',
  name: 'user',
  component: User,
  meta: {
    title: "用户"
  }
}, {
  path: '/user/course',
  name: 'user-course',
  component: UserCourse,
  meta: {
    title: "用户课程"
  }
}, {
  path: '/user/order',
  name: 'user-order',
  component: UserOrder,
  meta: {
    title: "用户订单"
  }
}, {
  path: '/user/create',
  name: 'user-create',
  component: CreateUser,
  meta: {
    title: "创建用户"
  }
}, {
  path: '/user/give-course',
  name: 'give-course',
  component: GiveCourse,
  meta: {
    title: "赠送课程"
  }
}, {
  path: '/user/give-coupon',
  name: 'give-coupon',
  component: GiveCoupon,
  meta: {
    title: "赠送优惠券"
  }
}, {
  path: '/order',
  name: 'order',
  component: Order,
  meta: {
    title: "订单"
  }
}, {
  path: '/order/info',
  name: 'order-info',
  component: OrderInfo,
  meta: {
    title: "订单详情"
  }
}, {
  path: '/order/change',
  name: 'order-change',
  component: OrderChange,
  meta: {
    title: "订单改价"
  }
}, {
  path: '/sales-tracking',
  name: 'sales-tracking',
  component: SalesTracking,
  meta: {
    title: "跟单管理"
  }
}, {
  path: '/sales-tracking/view',
  name: 'sales-tracking-view',
  component: SalesTrackingView,
  meta: {
    title: "跟单管理查看"
  }
}, {
  path: '/sales-tracking/info',
  name: 'sales-tracking-info',
  component: SalesTrackingInfo,
  meta: {
    title: "跟单管理编辑"
  }
}, {
  path: '/signup',
  name: 'signup',
  component: Signup,
  meta: {
    title: "线下报名"
  }
}, {
  path: '/signup/view',
  name: 'signup-view',
  component: SignupView,
  meta: {
    title: "线下报名查看"
  }
}, {
  path: '/signup/info',
  name: 'signup-info',
  component: SignupInfo,
  meta: {
    title: "线下报名编辑"
  }
}, {
  path: '/feedback',
  name: 'feedback',
  component: Feedback,
  meta: {
    title: "用户反馈"
  }
}, {
  path: '/comment',
  name: 'comment',
  component: Comment,
  meta: {
    title: "评论管理"
  }
}, {
  path: '/coupon',
  name: 'coupon',
  component: Coupon,
  meta: {
    title: "优惠券"
  }
}, {
  path: '/login',
  name: 'login',
  component: Login,
  meta: {
    title: "登录"
  }
}, {
  path: '/error_401',
  name: 'error_401',
  component: error_401,
  meta: {
    title: "401错误"
  }
}, {
  path: '/test',
  name: 'test',
  component: Test,
  meta: {
    title: "测试"
  }
}, {
  path: '/classhour',
  name: 'classhour',
  component: Classhour,
  meta: {
    title: "面授课表"
  }
}, {
  path: '/classhour/sign',
  name: '/classhour/sign',
  component: ClasshourSign,
  meta: {
    title: "签到统计"
  }
}, {
  path: '/classhour/qrcode',
  name: '/classhour/qrcode',
  component: ClasshourQrcode,
  meta: {
    title: "签到码"
  }
}]);
// EXTERNAL MODULE: ./src/store/index.js + 3 modules
var store = __webpack_require__("IcnI");

// EXTERNAL MODULE: ./src/libs/util.js + 1 modules
var util = __webpack_require__("TVG1");

// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  routes: routers
});
var router_TurnTo = function TurnTo(to, access, next) {
  if (Object(util["a" /* canTurnTo */])(to.name, access, routers)) next(); // 有权限，可访问
  else next({ replace: true, name: 'error_401' }); // 无权限，重定向到401页面
};

var VueRouterPush = vue_router_esm["a" /* default */].prototype.push;
vue_router_esm["a" /* default */].prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(function (err) {
    return err;
  });
};

var LOGIN_PAGE_NAME = 'login';

router.beforeEach(function (to, from, next) {

  store["a" /* default */].commit('updateLoadingStatus', { isLoading: true });

  var token = Object(util["g" /* getToken */])();
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    });
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next(); // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    next({
      name: 'home' // 跳转到homeName页
    });
  } else {
    if (store["a" /* default */].state.user.hasGetInfo) {
      router_TurnTo(to, store["a" /* default */].state.user.access, next);
    } else {
      store["a" /* default */].dispatch('getUserInfo').then(function (user) {
        // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
        router_TurnTo(to, user.access, next);
      }).catch(function () {
        Object(util["n" /* setToken */])('');
        next({
          name: 'login'
        });
      });
    }
  }
});

router.afterEach(function (to) {
  Object(util["m" /* setTitle */])(to, router.app);
  store["a" /* default */].commit('updateLoadingStatus', { isLoading: false });
});

/* harmony default export */ var src_router = __webpack_exports__["a"] = (router);

/***/ }),

/***/ "f/mU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.11.1@vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.11.1@vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7d12b4c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.11.1@vux/src/components/badge/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_badge = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.11.1@vux/src/components/badge/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("OQnN")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_badge,
  src_components_badge,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_11_1_vux_src_components_badge = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wJUw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xXZE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("aA9S");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("3cXf");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/promise.js
var promise = __webpack_require__("rVsN");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("ZLEe");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("AA3o");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("xSur");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/_axios@0.15.3@axios/index.js
var _axios_0_15_3_axios = __webpack_require__("6sKG");
var _axios_0_15_3_axios_default = /*#__PURE__*/__webpack_require__.n(_axios_0_15_3_axios);

// EXTERNAL MODULE: ./src/store/index.js + 3 modules
var store = __webpack_require__("IcnI");

// EXTERNAL MODULE: ./node_modules/_vue@2.6.14@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("yf3K");

// EXTERNAL MODULE: ./node_modules/_vux@2.11.1@vux/src/plugins/alert/index.js + 2 modules
var plugins_alert = __webpack_require__("xls9");

// CONCATENATED MODULE: ./src/libs/axios.js











vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);

var axios_addErrorLog = function addErrorLog(errorInfo) {
  var statusText = errorInfo.statusText,
      status = errorInfo.status,
      responseURL = errorInfo.request.responseURL;

  var info = {
    type: 'ajax',
    code: status,
    mes: statusText,
    url: responseURL
  };
  if (!responseURL.includes('save_error_logger')) store["a" /* default */].dispatch('addErrorLog', info);
};

var axios_HttpRequest = function () {
  function HttpRequest() {
    var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : baseURL;

    classCallCheck_default()(this, HttpRequest);

    this.baseUrl = baseUrl;
    this.queue = {};
  }

  createClass_default()(HttpRequest, [{
    key: 'getInsideConfig',
    value: function getInsideConfig() {
      var config = {
        baseURL: this.baseUrl,
        headers: {
          "auth-identity": store["a" /* default */].state.user.token
        }
      };
      return config;
    }
  }, {
    key: 'destroy',
    value: function destroy(url) {
      delete this.queue[url];
      if (!keys_default()(this.queue).length) {}
    }
  }, {
    key: 'interceptors',
    value: function interceptors(instance, url) {
      var _this = this;

      instance.interceptors.request.use(function (config) {

        if (!keys_default()(_this.queue).length) {}
        _this.queue[url] = true;
        return config;
      }, function (error) {
        return promise_default.a.reject(error);
      });

      instance.interceptors.response.use(function (res) {
        _this.destroy(url);
        var data = res.data,
            status = res.status;

        if (status == 200) {
          if (data.code !== 200) {
            vue_esm["a" /* default */].$vux.alert.show({
              title: '错误!',
              content: data.msg,
              onShow: function onShow() {
                console.log('Plugin: I\'m showing');
              },
              onHide: function onHide() {
                console.log('Plugin: I\'m hiding');
              }
            });
          }
        } else {
          vue_esm["a" /* default */].$vux.alert.show({
            title: '错误',
            content: '\u72B6\u6001\u7801\u3010' + status + '\u3011',
            onShow: function onShow() {
              console.log('Plugin: I\'m showing');
            },
            onHide: function onHide() {
              console.log('Plugin: I\'m hiding');
            }
          });
        }
        return { data: data, status: status };
      }, function (error) {
        _this.destroy(url);
        var errorInfo = error.response;
        if (!errorInfo) {
          var _JSON$parse = JSON.parse(stringify_default()(error)),
              _JSON$parse$request = _JSON$parse.request,
              statusText = _JSON$parse$request.statusText,
              status = _JSON$parse$request.status,
              config = _JSON$parse.config;

          errorInfo = {
            statusText: statusText,
            status: status,
            request: { responseURL: config.url }
          };
        }
        axios_addErrorLog(errorInfo);
        return promise_default.a.reject(error);
      });
    }
  }, {
    key: 'request',
    value: function request(options) {
      var instance = _axios_0_15_3_axios_default.a.create();
      options = assign_default()(this.getInsideConfig(), options);
      this.interceptors(instance, options.url);
      return instance(options);
    }
  }]);

  return HttpRequest;
}();

/* harmony default export */ var axios = (axios_HttpRequest);
// EXTERNAL MODULE: ./src/config/index.js
var src_config = __webpack_require__("2uFj");

// CONCATENATED MODULE: ./src/libs/api.request.js


var api_request_baseUrl =  false ? config.baseUrl.dev : src_config["a" /* default */].baseUrl.pro;

var api_request_axios = new axios(api_request_baseUrl);
/* harmony default export */ var api_request = __webpack_exports__["a"] = (api_request_axios);

/***/ }),

/***/ "zX7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.11.1@vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("vCyh");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.11.1@vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.11.1@vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-fcf1662a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.11.1@vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.11.1@vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("QaDJ")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_11_1_vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.427206846c5a012478ac.js